var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStorageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "storage-icon",
    transform: "translate(-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8505",
    "data-name": "Path 8505",
    d: "M42.154,48.565a.521.521,0,0,1-.519.522H38.519A.521.521,0,0,1,38,48.565V47.522A.521.521,0,0,1,38.519,47h3.115a.521.521,0,0,1,.519.522Z",
    transform: "translate(-15.385 -27.174)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8506",
    "data-name": "Path 8506",
    d: "M31.631,16.628a3.062,3.062,0,0,0,.331-1.367,3.126,3.126,0,0,0-3.115-3.13,3.032,3.032,0,0,0-1.12.223,4.146,4.146,0,0,0-8.09-.223H11.315a2.614,2.614,0,0,0-2.54,2.063L6.011,27.151,6,28.266c0,.013,0,.026,0,.039v3.13A1.563,1.563,0,0,0,7.558,33H27.288a1.563,1.563,0,0,0,1.558-1.565V27.261L27.54,21.522H30.4a2.6,2.6,0,0,0,1.227-4.893ZM27.808,31.435a.521.521,0,0,1-.519.522H7.558a.521.521,0,0,1-.519-.522V28.3a.521.521,0,0,1,.519-.522H27.288a.521.521,0,0,1,.519.522v3.13Zm-.12-4.637a1.533,1.533,0,0,0-.4-.058H7.558a1.537,1.537,0,0,0-.409.062L7.384,25.7h9V24.652H7.606l.223-1.043h5.959V22.565H8.051l.222-1.043H12.75V20.478H8.5l.222-1.043h2.992V18.391H8.942l.848-3.979a1.57,1.57,0,0,1,1.524-1.239H19.5v1.085a3.651,3.651,0,0,0,.519,7.263h6.457ZM30.4,20.478H20.019a2.609,2.609,0,0,1,0-5.217h1.557V14.217H20.538V13.174a3.115,3.115,0,1,1,6.231,0v1.043h1.038v-.748a2.021,2.021,0,0,1,1.038-.3,2.084,2.084,0,0,1,2.077,2.087,2.033,2.033,0,0,1-.308,1.065c-.071-.006-.139-.021-.211-.021H29.365v1.043H30.4a1.565,1.565,0,0,1,0,3.13Z",
    transform: "translate(0 -9)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8507",
    "data-name": "Path 8507",
    d: "M11.038,47a1.043,1.043,0,1,0,1.038,1.043A1.041,1.041,0,0,0,11.038,47Z",
    transform: "translate(-1.923 -27.174)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8508",
    "data-name": "Path 8508",
    d: "M17.038,47a1.043,1.043,0,1,0,1.038,1.043A1.041,1.041,0,0,0,17.038,47Z",
    transform: "translate(-4.808 -27.174)",
    fill: "#325ae7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8509",
    "data-name": "Path 8509",
    d: "M23.038,47a1.043,1.043,0,1,0,1.038,1.043A1.041,1.041,0,0,0,23.038,47Z",
    transform: "translate(-7.692 -27.174)",
    fill: "#325ae7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageIcon);
export default __webpack_public_path__ + "static/media/storage-icon.9a62587dbfc19e5d490c4ecb199e64b3.svg";
export { ForwardRef as ReactComponent };